var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "uk-icon": _vm.definition
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20363974","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Icon.vue
// module id = 1897
// module chunks = 0